import { ChangeEvent, FC, useState } from 'react';
import { useDispatch } from 'react-redux';
import dayjs from 'dayjs';
import { unwrapResult } from '@reduxjs/toolkit';
import { Tooltip } from '@mui/material';

import { errorNormalizer } from '../../../shared/Helpers/functions';
import { CustomAlert, CustomButton, CustomCheckBox } from '../../../shared/uiComponents';
import { Download } from '../../../shared/Assets/svgIcons';
import { downloadFile } from '../../Reports/helpers';

import { DispatchProperties, useSelector } from '../../../redux/store';
import { downloadSoapNotePDF } from '../../../redux/State/exportSlice';
import { SoapNotesFullProperties } from '../../../redux/API/ClientAPIHelpers/soapNoteProperties';

const DownloadSOAPNote: FC<{
	data: SoapNotesFullProperties;
}> = ({ data }) => {
	const dispatch = useDispatch<DispatchProperties>();

	const { id, client, submittedAt } = data;

	const [open, setOpen] = useState<boolean>(false);
	const [includeTrials, setIncludeTrials] = useState<boolean>(false);

	const loading = useSelector((state) => state.export.loading);

	const downloadSoapNoteHandler = () => {
		dispatch(
			downloadSoapNotePDF({
				reportId: id,
				includeTrials,
			}),
		)
			.then(unwrapResult)
			.then((response) => {
				const date = dayjs(submittedAt).format('MM-DD-YYYY-hh-mm-a');
				downloadFile({
					file: response,
					fileName: `${client.fullName}-${date}`,
				});
			})
			.catch(errorNormalizer)
			.finally(() => setOpen(false));
	};

	const includeTrialsHandler = (event: ChangeEvent<HTMLInputElement>) => {
		const { checked } = event.target;
		setIncludeTrials(checked);
	};
	const isDownloading = useSelector((state) => state.export.isDownloading);

	return (
		<>
			<Tooltip title="Download PDF">
				<div onClick={() => setOpen(true)}>
					<Download />
				</div>
			</Tooltip>
			<CustomAlert
				isBusy={isDownloading}
				title="Include Trials?"
				open={open}
				onClose={() => setOpen(false)}
				Content={() => (
					<>
						<CustomCheckBox
							item={{
								id: '1',
								checked: includeTrials,
								label: 'Include',
							}}
							onChange={includeTrialsHandler}
						/>
						<CustomButton
							disabled={isDownloading}
							title="Download PDF"
							onClick={downloadSoapNoteHandler}
							loading={loading}
						/>
					</>
				)}
			/>
		</>
	);
};

export default DownloadSOAPNote;
